// Tiny utility to grab UTM params + referrer once per session.
// Persists in sessionStorage so deep-link UTMs survive nav.

const KEY = "ridgehawk:utm";

export function captureUTM() {
  if (typeof window === "undefined") return {};
  try {
    const cached = sessionStorage.getItem(KEY);
    if (cached) return JSON.parse(cached);
  } catch (_) {
    /* noop */
  }
  const params = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    referrer: document.referrer || null,
  };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(utm));
  } catch (_) {
    /* noop */
  }
  return utm;
}

export function buildMeta() {
  const utm = captureUTM();
  return {
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    referrer: utm.referrer,
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
  };
}
